export enum WorkingDiagnosis {
    ernstigOSAS = 'Ernstig OSAS',
    geenOSAS = 'Geen OSAS',
    lichtOSAS = 'Licht OSAS',
    matigOSAS = 'Matig OSAS',
}
